var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SystemDialog",
    {
      attrs: {
        persistent: "",
        "content-class": "confirm-dialog",
        "max-width": _vm.maxWidth,
        "show-header": !_vm.hasCardTitleSlot,
        "show-close": !_vm.hasCardTitleSlot,
        "actions-align": "center",
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u(
        [
          !_vm.hasCardTitleSlot
            ? {
                key: "title",
                fn: function () {
                  return [_vm._t("title", null, { options: _vm.formData })]
                },
                proxy: true,
              }
            : null,
          {
            key: "actions",
            fn: function () {
              return [
                _vm._t(
                  "footer",
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "text-none",
                        attrs: {
                          depressed: "",
                          small: "",
                          color: "primary",
                          outlined: "",
                        },
                        on: { click: _vm.close },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("button.cancel")) +
                            "\n      "
                        ),
                      ]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "text-none",
                        attrs: {
                          depressed: "",
                          small: "",
                          color: "primary",
                          loading: _vm.loading,
                        },
                        on: { click: _vm.ok },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("button.confirm")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  { ok: _vm.ok, close: _vm.close }
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm.hasCardTitleSlot
        ? _c(
            "div",
            { staticClass: "confirm-dialog__custom-header" },
            [
              _vm._t("card-title", null, {
                close: _vm.close,
                options: _vm.formData,
                ok: _vm.ok,
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "confirm-dialog__content" },
        [
          _vm._t("default"),
          _vm._t(
            "content",
            [_vm._v("\n      " + _vm._s(_vm.formData.content) + "\n    ")],
            { options: _vm.formData }
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }